// removed by extract-text-webpack-plugin
module.exports = {"container":"App__container___71KmR","button":"App__button___3T8ui"};